import Vue from 'vue'
import App from './App.vue'
import axios from './utils/axios'
import VueAxios from 'vue-axios'
import { Sierotki } from 'sierotki'
import Vuelidate from 'vuelidate'
import router from './router'

Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.config.productionTip = true

Vue.prototype.sierotki = function (value) {
  if (!value) return ''
  value = value.toString()
  return Sierotki.orphansFix(value);
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')